<div class="login-registration-container">
  <mat-card appearance="outlined" class="login-card">
    <h3 translate>anonymous_login</h3>
    <mat-spinner [style.display]="!progress? 'none' : 'block'"></mat-spinner>

    <form [style.display]="progress? 'none' : 'block'">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label translate>login</mat-label>
        <input autocomplete="off" matInput #loginInput type="text" name="login"
          [formControl]="loginControl"
          [attr.disabled]="authStep == STEP_ANONYMOUS || authStep == STEP_REGISTERED ? true : null"/>
          <mat-hint align="end">{{loginInput.value.length}} / {{LOGIN_MAX_LENGTH}}</mat-hint>
          @if (loginControl.errors) {
            <mat-error>
              {{getLoginError()}}
            </mat-error>
          }
        </mat-form-field>

        @if (authStep == STEP_ANONYMOUS || authStep == STEP_REGISTERED) {
          <app-gender-select [genderControl]="genderControl"></app-gender-select>
        }

        @if (authStep == STEP_REGISTERED) {
          <mat-form-field class="full-width" appearance="fill">
            <mat-label translate>password</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'" name="password"
              [formControl]="passwordControl"/>
              <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
                matTooltip="{{'hide_show_password' | translate}}">
                <mat-icon color="primary">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-hint align="end">{{passwordControl.value.length}} / {{PASSWORD_MAX_LENGTH}}</mat-hint>
              @if (passwordControl.errors) {
                <mat-error>
                  {{getPasswordError(passwordControl)}}
                </mat-error>
              }
            </mat-form-field>
          }
          @if (authStep == STEP_REGISTERED) {
            <mat-error class="full-width" style="text-align: end">
              <a routerLink="/auth/restore">
                {{'forgot_a_password' | translate}}
              </a>
            </mat-error>
          }

          @if (invisibleFieldShowed) {
            <mat-checkbox class="full-width" [(ngModel)]="isInvisibleChecked"
              name="invisible">
              {{'login_as_invisible' | translate}}
            </mat-checkbox>
          }


        @if (authStep != STEP_LOGIN) {
            <!--<re-captcha #captcha
              (resolved)="captchaResolved($event)"
              (errored)="captchaError($event)"
              siteKey="6LfYMRMaAAAAAMl-RBe7dA4eJAh5JfU7bPIN4zKo">
            </re-captcha>-->
            <ng-hcaptcha #captcha
                         [size]="captchaSize"
                         (verify)="captchaResolved($event)"
                         (expired)="captchaExpired()"
                         (error)="captchaError($event)">
            </ng-hcaptcha>
      }
      @if (authStep != STEP_LOGIN && captchaToken=='') {
        <mat-error translate>you_should_solve_a_captcha
        </mat-error>
      }

      @if (error) {
        <mat-error>{{error}}</mat-error>
      }
      @if (needEmailConfirm) {
        <mat-error>
          {{'not_receive_confirmation_email' | translate}}
          <a (click)="$event.preventDefault();resendConfirmationEmail()" href="">
            {{'send_email_one_more_time' | translate}}
          </a>
        </mat-error>
      }

      <div style="margin-top: 1rem" class="buttons">
        <button class="full-width" mat-raised-button color="accent" type="submit"
        (click)="login()">{{authStep == STEP_LOGIN ? ('entrance' | translate) : ('enter' | translate)}}</button>

        @if (authStep == STEP_LOGIN) {
          <p style="width: 100%;text-align: center;">
            {{'or' | translate | uppercase}}
          </p>
        }

        @if (authStep == STEP_LOGIN) {
          <button class="full-width"
            mat-button
            color="primary"
            routerLink="/auth/registration">
            {{'registration' | translate}}
          </button>
        }

        @if (authStep != STEP_LOGIN) {
          <button class="full-width" mat-stroked-button color="accent" (click)="cancel()"
            >
            {{'cancel' | translate}}
          </button>
        }
      </div>

    </form>
  </mat-card>
</div>
